module.exports = __webpack_public_path__ + "images/company/rank_medal/selling_agreement_count_rank/2_623d6070b12353c9e506aa6682d6ed13.png";